export const INCREMENT_LOADER_COUNT = "INCREMENT_LOADER_COUNT";
export const DECREMENT_LOADER_COUNT = "DECREMENT_LOADER_COUNT";
export const SET_USER = "SET_USER";
export const SET_LICENCES = "SET_LICENCES";
export const SET_SELECTED_ORG = "SET_SELECTED_ORG";
export const SET_USER_ROLES = "SET_USER_ROLES";
export const SET_OFFERING_TYPES = "SET_OFFERING_TYPES";
